import Vue from "vue";
import axios from "../request/axios";

Vue.prototype.$get = axios.get;
Vue.prototype.$post = axios.post;
Vue.prototype.$getpay = axios.getpay;
Vue.prototype.$postpay = axios.postpay;